import type { IHostedMinerFilters } from '@/types/hvl/filters'
import type { IHostedMiner } from '@/types/hvl/HostedMiner'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export async function getHostedMiners(filters: IHostedMinerFilters): Promise<IPage<IHostedMiner>> {
  const res = await axios.get(import.meta.env.VITE_APP_HVL_HOSTED_MINERS_ENDPOINT, {
    params: filters,
  })
  return res.data
}

export async function refreshHostedMiners(): Promise<any> {
  const res = await axios.post(`${import.meta.env.VITE_APP_HVL_HOSTED_MINERS_ENDPOINT}/refresh`)
  return res.data
}

export async function bulkDeleteHostedMiners(ids: number[]): Promise<any> {
  const res = await axios.delete(`${import.meta.env.VITE_APP_HVL_HOSTED_MINERS_ENDPOINT}/bulk`, {
    data: { ids },
  })
  return res.data
}
